/* eslint-disable jsx-a11y/anchor-is-valid */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { contactDetails, gallery } from "../mock/Footer";

const Footer = () => {
  return (
    <footer className="bg_img bg-dark">
      <div className="container py-5">
        <div className="row">
          <div className="col-md-4">
            <h3 className="mb-3">
              <img
                src="images/logo.png"
                alt="logo"
                style={{ width: "85px", height: "75px" }}
              />
            </h3>
            <p>
              We have completed 5 projects, each project consists of around 50
              houses.
            </p>
            <p>
              We’re a challenge driven team that loves to build meaningful
              living spaces with people that share the same passion and values
              as we have.
            </p>
          </div>
          <div className="col-md-4">
            <h3 className="text-white mb-5">Contact Us</h3>
            {contactDetails.map((item) => (
              <div className="d-flex" key={item.id}>
                <FontAwesomeIcon
                  icon={item.icon}
                  className="mx-2 text-secondary"
                />
                <p>
                  {item.title}: {item.content}
                </p>
              </div>
            ))}
          </div>
          <div className="col-md-4">
            <h3 className="text-white mb-5">Recent Photos</h3>
            <ul className="list-unstyled">
              {gallery.map((item) => (
                <li key={item.id}>
                  <a href={item.id}>
                    <img src={item.link} alt={item.alt} />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <hr className="text-secondary" />
        <div className="col-12 d-flex justify-content-center copyright_text">
          <p>
            © 2022 Warraich Traders. All Rights Reserved.
            <br />
            Designed and Developed by
            <a
              href="https://bytebunch.com"
              target="_blank"
              className="text-decoration-none text-white mx-2"
              rel="noreferrer"
            >
              ByteBunch
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
